function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Uploader from "../../utils/uploader";
import RedactorX from "../../static/redactorx";
import "../../static/redactorx.css";
import "../../static/plugins/icons/icons";
import "../../static/plugins/inlineformat/inlineformat";
import "../../static/plugins/specialchars/specialchars";
import "../../static/plugins/textdirection/textdirection";
import "../../static/plugins/underline/underline";
export default {
  props: {
    spec: {
      type: Object,
      "default": null
    }
  },
  data: function data() {
    return {
      rawValue: "",
      cleanValue: "",
      progress: {
        value: -1
      },
      images: {},
      imageKeys: []
    };
  },
  computed: {
    showProgress: function showProgress() {
      return this.progress.value >= 0;
    }
  },
  methods: {
    $ready: function $ready() {
      this.initValue();
      this.initRedactor();
    },
    initValue: function initValue() {
      var _this = this;

      var rawValue = this.spec.value || "";
      Utils.type.ifArray(this.spec.images, function (images) {
        var vm = _this;
        rawValue = rawValue.replace(/\{\{image([0-9]+)\}\}/g, function (_, index) {
          var image = images[index - 1];

          if (image && vm.$type.isString(image.value) && vm.$type.isString(image.fileUrl)) {
            var url = image.fileUrl;
            var key = url.hashCode().toString();
            vm.images[key] = image.value; // return `<img src="${url}">`;

            return url;
          }

          return "{{IMAGE_NOT_FOUND}}";
        });
      });
      this.updateValue(rawValue);
    },
    initRedactor: function initRedactor() {
      var vm = this;
      RedactorX("#editor", {
        content: this.rawValue,
        source: Utils.settings.isDev,
        plugins: ["inlineformat", "style"],
        image: {
          upload: function upload(_upload, data) {
            for (var key in data.files) {
              if (_typeof(data.files[key]) === "object") {
                var file = data.files[key];
                vm.uploadImage(file, function (response) {
                  _upload.complete(response, data.e);
                });
              }
            }
          }
        },
        subscribe: {
          "editor.change": function editorChange(event) {
            var content = this.app.editor.getContent();
            vm.updateValue(content);
          }
        }
      });
    },
    updateValue: function updateValue(content) {
      this.rawValue = content;
      this.separateOutImages();
    },
    separateOutImages: function separateOutImages() {
      var vm = this;
      var index = 0;
      vm.imageKeys.clear(); // TODO: Fix to avoid replacing <video src="">

      this.cleanValue = this.rawValue.replace(/src="([^"]+)"/g, function (_, imageValue) {
        // It seems that quill encodes '&' in the URL to '&amp;' which would screw up key matching.
        var decodedValue = imageValue.replace(/&amp;/g, "&");
        var key = decodedValue.hashCode().toString();
        var existingIndex = vm.imageKeys.indexOf(key);

        if (existingIndex < 0) {
          vm.imageKeys.push(key);
          return "src=\"{{image".concat(++index, "}}\"");
        }

        return "src=\"{{image".concat(existingIndex + 1, "}}\"");
      });
    },
    uploadImage: function uploadImage(file, onComplete) {
      var _this2 = this;

      var uploaderSpec = this.spec.imageUploader;
      var upload = new Uploader(file, uploaderSpec.directUploadUrl, this.progress);

      if (upload.validateFile(uploaderSpec)) {
        upload.start(function (error, blob) {
          if (error) {
            // Handle the error
            console.log("Failed uploading image!");
          } else {
            _this2.insertImage(file, blob, onComplete);
          }
        });
      }
    },
    insertImage: function insertImage(file, blob, onComplete) {
      var vm = this;
      var reader = new FileReader();

      reader.onload = function (e) {
        if (file.type.indexOf("image") !== -1) {
          var image = new Image();
          image.src = e.target.result;
          var key = image.src.hashCode().toString();

          image.onload = function () {
            var response = _defineProperty({}, key, {
              url: image.src,
              id: key
            });

            onComplete(response);
          };

          vm.images[key] = blob.signed_id;
        }
      };

      reader.readAsDataURL(file);
      vm.progress.value = -1;
    }
  }
};